module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainPage"
    }
  }, [_c('h1', [_vm._v("这里是首页")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32becccd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/callback.vue
// module id = 1806
// module chunks = 502